import { useDocumentTitle } from '@/hooks';
import BrandPane from '@/pages/auth/BrandPane.jsx';
import PropTypes from 'prop-types';

import '@/pages/auth/login.css';

// Public Toku return (REC-1503). No session. `/payment/status` stays behind
// auth for the logged-in estudio cobro. Paths must match recepthor-api
// `PUBLIC_CHECKOUT_RETURN_PATHS`.
const COPY = {
  recibido: {
    body: 'El cobro de la diligencia quedó registrado. Puedes cerrar esta ventana.',
    heading: 'Recibimos tu pago',
    title: 'Pago recibido',
  },
  'no-completado': {
    body: 'No se cobró. Vuelve al enlace de pago que te enviamos e intenta de nuevo.',
    heading: 'El pago no se completó',
    title: 'Pago no completado',
  },
};

export default function PublicPaymentResult({ outcome }) {
  const copy = COPY[outcome];
  useDocumentTitle(copy.title);

  return (
    <div className="login-page">
      <BrandPane />
      <div className="login-form-pane">
        <div className="login-form login-form--payment-result">
          <p className="login-eyebrow">Confirmación de pago</p>
          <h1 className="login-heading login-heading--payment">
            {copy.heading}
          </h1>
          <p className="recover-subtitle">{copy.body}</p>
        </div>
      </div>
    </div>
  );
}

PublicPaymentResult.propTypes = {
  outcome: PropTypes.oneOf(['recibido', 'no-completado']).isRequired,
};
